import {
  SET_SUBSEGMENTS_LIST_DATA,
  OPEN_SUBSEGMENTS_FORM_MODAL,
  CLOSE_SUBSEGMENTS_FORM_MODAL
} from '../constants/action_constants';

const initialState = {
  configs: [],
  meta: {},
  formModalIsOpen: false
};

export function subSegment(state = initialState, action) {
  switch (action.type) {
    case SET_SUBSEGMENTS_LIST_DATA:
      return {
        ...state,
        configs: action.data,
        meta: {
          totalCount: action.meta.totalCount,
          currentPage: action.meta.currentPage
        }
      };
    case OPEN_SUBSEGMENTS_FORM_MODAL:
      return {
        ...state,
        formModalIsOpen: true
      };
    case CLOSE_SUBSEGMENTS_FORM_MODAL:
      return {
        ...state,
        formModalIsOpen: false
      };
    default: {
      return state;
    }
  }
};